// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qRhpb","left":"styles_left__voNDL","desktopActions":"styles_desktopActions__1BvcD","title":"styles_title__3X3yg"};